import './FormSection.css'

const FormSection = ({ title, subtitle, children, className = '' }) => {
  const titleText = typeof title === 'string' ? title : ''
  const numberMatch = titleText.match(/^(\d+)\.\s*(.+)$/)
  const sectionNumber = numberMatch ? numberMatch[1] : null
  const sectionTitle = numberMatch ? numberMatch[2] : title

  return (
    <section className={`form-section ${className}`}>
      <h2 className="form-section__title">
        {sectionNumber && <span className="form-section__title-badge">{sectionNumber}</span>}
        <span className="form-section__title-text">{sectionTitle}</span>
      </h2>
      {subtitle && <h3 className="form-section__subtitle">{subtitle}</h3>}
      <div className="form-section__content">
        {children}
      </div>
    </section>
  )
}

export default FormSection
